import { render, staticRenderFns } from "./UserMeetings.vue?vue&type=template&id=f8088c9c&"
import script from "./UserMeetings.vue?vue&type=script&lang=ts&"
export * from "./UserMeetings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports